import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import { styled } from '@mui/system';

import { StatusColors } from '../../utils/Config';
import CellContent from './CellContent';

const itemLabelMap = {
  tposku: 'TPO SKU Code',
  TPOSKU: 'TPO SKU Code',
  tposkuname: 'TPO SKU DESCRIPTION',
  TPOSKUName: 'TPO SKU DESCRIPTION',
  udcjdacode: 'UPC',
  UDCJDACode: 'UPC',
  materialID: 'MATERIAL ID',
  MaterialID: 'MATERIAL ID',
  materialName: 'MATERIAL NAME',
  MaterialName: 'MATERIAL NAME',
  brandName: 'BRAND NAME',
  BrandName: 'BRAND NAME',
  subBrandName: 'SUB-BRAND NAME',
  SubBrandName: 'SUB-BRAND NAME',
  TPOSkuClassName: 'MANUFACTURING CLASS',
  ProductHierarchyLevel1Description: 'PRODUCT LINE', 
  ProductHierarchyLevel2Description: 'PRODUCT GROUP',
  TPOSkuFlavorName: 'FLAVOR',
  TPOSkuSizeName: 'SIZE',
  PackageTypeName: 'PACK TYPE',
  MaterialNetWeightQuantity: 'WEIGHT',
  GrossSales: 'GROSS SALES',
  GSvsLY: 'GS vs LY',
  OnTicketTradeSpend: 'ON-TICKET TRADE SPEND',
  NetInvoiceSales: 'NET INVOICE SALES',
  NSvsLY: 'NS vs LY',
  OffTicketTradeSpend: 'OFF-TICKET TRADE SPEND',
  NetRevenue: 'NET REVENUE',
  COGS: 'COGS',
  GrossProfit: 'GROSS PROFIT',
  GPPercent: 'GP %',
  TotalSD: 'TOTAL S&D',
  NetProfit: 'NET PROFIT',
  NPvsLY: 'NP vs LY',
  CasesvsLY: 'CASES vs LY',
  WeightvsLY: 'WEIGHT vs LY',
  TotalWaste: 'TOTAL WASTE ($)',
  FacilityCountL12W: 'FACILITY COUNT L12W',
  NetVolume: 'VOLUME QTY'
};

const itemTypeMap = {
  tposku: 'text',
  TPOSKU: 'text',
  tposkuname: 'text',
  TPOSKUName: 'text',
  udcjdacode: 'text',
  UDCJDACode: 'text',
  materialID: 'text',
  MaterialID: 'text',
  materialName: 'text',
  MaterialName: 'text',
  brandName: 'text',
  BrandName: 'text',
  subBrandName: 'text',
  SubBrandName: 'text',
  TPOSkuClassName: 'text',
  ProductHierarchyLevel1Description: 'text', 
  ProductHierarchyLevel2Description: 'text',
  TPOSkuFlavorName: 'text',
  TPOSkuSizeName: 'text',
  PackageTypeName: 'text',
  MaterialNetWeightQuantity: 'number',
  GrossSales: 'number',
  GSvsLY: 'number',
  OnTicketTradeSpend: 'number',
  NetInvoiceSales: 'number',
  NSvsLY: 'number',
  OffTicketTradeSpend: 'number',
  NetRevenue: 'number',
  COGS: 'number',
  GrossProfit: 'number',
  GPPercent: 'number',
  TotalSD: 'number',
  NetProfit: 'number',
  NPvsLY: 'number',
  CasesvsLY: 'number',
  WeightvsLY: 'number',
  TotalWaste: 'number',
  FacilityCountL12W: 'number',
  NetVolume: 'number'
};

const DetailTable = ({ childData = [] }) => {
  const getLabel = (item) => {
    return itemLabelMap[item] || item?.toUpperCase()
  };

  const getType = (item) => {
    return itemTypeMap[item] || "text"
  };

  const columns = Object.keys(childData[0] ?? {}).map((item) => ({
    id: item,
    label: getLabel(item),
    type: getType(item),
    defaultValue: '-'
  }));

  const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    padding: '0px 32px',
    width: '90vw'
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:not(:last-child)': {
      borderBottom: '1.5px solid #DFDFDF'
    }
  }));

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    // padding: "8px",
    color: '#616161',
    borderBottom: 'none'
  }));

  const StyledTableHeadCell = styled(StyledTableCell)(({ theme }) => ({
    fontSize: '12px',
    fontWeight: 700
  }));
  // console.log('childdata',childData)
  return (
    <StyledTableContainer>
      <Table size="small">
        <TableHead>
          <StyledTableRow>
            {columns.map((column) => (
              <StyledTableHeadCell key={column.id} align={column.align || 'left'}>
                {column.label}
              </StyledTableHeadCell>
            ))}
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {childData?.map((row, index) => (
            <StyledTableRow key={row.id || index}>
              {columns.map((column) => (
                <StyledTableCell key={column.id} align={column.align || 'left'}>
                  {column.id === 'status' ? (
                    <Box
                      sx={{
                        borderRadius: '4px',
                        padding: '2px 8px',
                        color: '#000000',
                        width: 'fit-content',
                        backgroundColor: StatusColors[row[column.id]]
                      }}>
                      {row[column.id]}
                    </Box>
                  ) : (
                    <CellContent
                                    columns={[...columns]}
                                    column={{ ...column }}
                                    row={{ ...row }}
                                    originalData={childData}
                                    isCycleEdit={false}
                                    editingRowId={false}
                                    showCycleSave={false}
                                  />
                  )}
                </StyledTableCell>
              ))}
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
};

export default DetailTable;
